import React, { useState, useRef, useEffect } from "react";
import { Card, CardContain } from "../../style/Home";
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    TextField,
    Menu,
    MenuItem,
    Button,
    FormControl,
    Select,
} from "@mui/material";
import EditNoteIcon from "@mui/icons-material/EditNote";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButtonContain } from "../../style/HO/CreateManualCard";
import { CommanTableContainDealerMaster } from "../../style/table";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
    DealerMasterModal,
    HierachyMasterModal,
} from "../../style/HO/MVRManualCreation";
import { GuidelineContain } from "../../style/AM/MoMStatusUpdate";
import { useSelector } from "react-redux";
import CloseIcon from "@mui/icons-material/Close";
import {
    ContainerCustomDealerMaster,
    PaginationContain,
    ContainerCustom,
    SmartSearchContain,
} from "../../style/table";
import SearchIcon from "@mui/icons-material/Search";
import {
    GetDealerData,
    UpdateDealer,
    ImportCsvFile,
    GetExcelFile,
} from "../../services/dealerMaster";
import "react-toastify/dist/ReactToastify.css";
import { ContainedButtton } from "../../style/HO/CreateManual";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import excelFile from "../../../src/assets/templates/Dealer_Templates.xlsx";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Loader } from "../../utils/loader";
import ExcelIcon from "../../assets/images/icons/excel.png";

const Dealer_Master = () => {
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [modalOpen, setModalOpen] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [showLoiImage, setShowLoiImage] = useState("");
    const Drawer = useSelector((state) => state.drawer);
    const [search, setSearch] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [selectedImage, setSelectedImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [loader, setLoader] = useState(false);
    const [dealerData, setDealerData] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [anchorE2, setAnchorE2] = useState(null);
    const openDownload = Boolean(anchorE2);
    const csvInputRef = useRef(null);

    const [fileType, setFileType] = useState("");

    const handleDownloadFile = async (mimeType) => {
        if(!mimeType){
            toast.warning("Excel type not found.");
            return;
        }
        try {
            const payload = {
                mimeType,
            };

            const response = await GetExcelFile({
                payload: payload,
            });

            if (response?.success && response?.url) {
                const link = document.createElement("a");
                link.href = response.url;
                link.target = "_blank";
                link.rel = "noopener noreferrer";
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        } catch (error) {
            console.error("Download failed:", error);
            toast.error("Network Error");
        } finally {
            setFileType("");
        }
    };
    const handleFileTypeChange = async (event) => {
        event.preventDefault();
        const selectedType = event.target.value;
        setFileType(selectedType);

        if (selectedType) {
            await handleDownloadFile(selectedType);
        }
    };

    const mvrTableCols = [
        "Dealer Code",
        "Dealer Name",
        "Contact No.",
        "Email Id",
        "Address",
        "Region",
        "Zone",
        "Area",
        "Country",
        "State",
        "City",
        "Pin code",
        "LOI Holder Name",
        "LOI Holder Photo",
        "LOI Issued Date",
        "Main DealerCode",
        "Main DealerName",
        "Status",
        "Edit",
    ];
    const getDealerData = async () => {
        try {
            setLoader(true);

            const payload = {
                search: debouncedSearchTerm,
                page: page,
                offset: rowsPerPage,
            };
            const res = await GetDealerData({ payload });
            if (res.success) {
                setDealerData(res?.data?.dealersData);
                console.log(res?.data?.dealersData);
                setTotalCount(res?.data?.totalDataCount);
            }
        } catch (error) {
            console.log("error", error);
            if (error.code === "ERR_NETWORK") {
                toast.error("Network error");
            }
        } finally {
            setLoader(false);
        }
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };

    const handleEditClick = (row) => {

        if (fileInputRef?.current?.value) {
            fileInputRef.current.value = ""
        }

        setPreviewImage(null);
        setSelectedImage(null);

        setSelectedRow(row);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
        setSelectedRow(null);
    };
    const fileInputRef = useRef(null);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedImage(file);
            const reader = new FileReader();
            reader.onload = (e) => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const triggerFileInput = () => {
        fileInputRef.current.click();
    };

    useEffect(() => {
        const handle = setTimeout(() => {
            setDebouncedSearchTerm(search);
        }, 600);
        return () => clearTimeout(handle);
    }, [search]);

    useEffect(() => {
        getDealerData();
    }, [rowsPerPage, page, debouncedSearchTerm]);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleDownloadOpen = (event) => {
        setAnchorE2(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleDownloadClose = () => {
        setAnchorE2(null);
    };

    const validateEmail = (email) => {
        const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return gmailRegex.test(email);
    };

    const validatePhone = (number) => {
        const phoneRegex = /^[6-9]\d{9}$/;
        return phoneRegex.test(number)
    }

    const handleSave = async (e) => {
        e.preventDefault();
        if (!validateEmail(selectedRow?.emailId)) {
            toast.error("Please enter a valid Email Id");
            return;
        }
        if (selectedRow?.phoneNumber && !validatePhone(selectedRow?.phoneNumber)) {
            toast.error("Please enter a valid phone number");
            return;
        }

        const row = selectedRow
        console.log(selectedRow);
        try {
            if (
                row?.emailId != "" &&
                row?.region != "" &&
                row?.zone != "" &&
                row?.area != "" &&
                row?.address != ""
            ) {

                const dealerMaster = new FormData();

                dealerMaster.append("contactNumber", row?.phoneNumber || "");
                dealerMaster.append("emailId", row?.emailId || "");
                dealerMaster.append("state", row?.state || "");
                dealerMaster.append("pinCode", row?.pinCode || "");
                dealerMaster.append("region", row?.region || "");
                dealerMaster.append("zone", row?.zone || "");
                dealerMaster.append("area", row?.area || "");
                dealerMaster.append("loiHolderName", row?.loiHolderName || "");
                dealerMaster.append("address", row?.address || "");
                dealerMaster.append("status", row?.status || "");

                let formattedDate = row?.loiIssueDate?.split("-").reverse().join("-") ?? ""
                dealerMaster.append("loiIssueDate", formattedDate);

                if (selectedImage instanceof File) {
                    dealerMaster.append("document", selectedImage);
                }
                const res = await UpdateDealer({
                    payload: dealerMaster,
                    employeeId: row.id,
                });

                if (res.success) {
                    setModalOpen(false);
                    await getDealerData();
                    toast.success("Updated Successfully");
                }
            } else {
                toast.error("Please filled the required field");
            }
        } catch (error) {
            // console.log(error);
            if (error.code === "ERR_BAD_REQUEST") {
                toast.error(error?.response?.data?.error);
            }
        }
    };

    const handleCsvChange = async (event) => {
        const file = event.target.files[0];
        if (!file) {
            toast.error("Please select a file");
            return;
        }

        setLoader(true);

        const formData = new FormData();
        formData.append("dealers", file);

        try {
            setLoader(true);
            const res = await ImportCsvFile({ payload: formData });
            if (res && res.success) {
                toast.success("Upload Successfully");
                await getDealerData();
            }
        } catch (error) {
            console.log("error: ", error);
            if (error.code === "ERR_BAD_RESPONSE") {
                toast.error(error?.response?.data?.error);
            } else {
                toast.error(error?.response?.data?.error);
            }
        } finally {
            setTimeout(() => {
                setLoader(false);
            }, 1000);
        }
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/* <div> */}
            <CardContain>
                <Card mt={2}>
                    <ContainerCustomDealerMaster>

                        <div className="import_btn">
                            <Button
                                variant="contained"
                                onClick={handleClick}
                                endIcon={<KeyboardArrowDownIcon />}
                            >
                                Import
                            </Button>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleClose}
                                disableScrollLock
                            >
                                <a href={excelFile} download="DealerTemplates.xlsx">
                                    <MenuItem onClick={() => {
                                        handleClose();
                                    }}>Get Template</MenuItem>
                                </a>
                                <MenuItem
                                    onClick={() => {
                                        csvInputRef.current.value = "";
                                        csvInputRef.current.click();
                                        handleClose();
                                    }}
                                >
                                    Upload Excel
                                </MenuItem>
                            </Menu>
                        </div>
                        <div className="import_btn import_btn_xcel">
                            <SmartSearchContain style={{ marginRight: "20px" }}>
                                <TextField
                                    label="Search"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    marginleft="auto"
                                    value={search}
                                    onChange={(e) => setSearch(e.target.value)}
                                />
                                <SearchIcon />
                            </SmartSearchContain>

                            <input
                                type="file"
                                style={{ display: "none" }}
                                ref={csvInputRef}
                                accept=".csv, .xls, .xlsx"
                                onChange={handleCsvChange}
                            />
                            {/* download file */}
                            <FormControl sx={{ minWidth: 70 }} size="small">
                                <Button
                                    variant="contained"
                                    onClick={handleDownloadOpen}
                                    endIcon={<KeyboardArrowDownIcon />}
                                >
                                    <img src={ExcelIcon} alt="Excel icon" />
                                </Button>
                                <Menu
                                    anchorEl={anchorE2}
                                    open={openDownload}
                                    onClose={handleDownloadClose}
                                    disableScrollLock
                                >
                                    <MenuItem onClick={()=> handleDownloadFile("csv")}>
                                        Download CSV
                                    </MenuItem>
                                    <MenuItem onClick={() => handleDownloadFile("xlsx")}>
                                        Download Excel
                                    </MenuItem>
                                </Menu>
                            </FormControl>
                        </div>
                    </ContainerCustomDealerMaster>
                    <GuidelineContain>
                        <div className="Guidelines">
                            <p>
                                <span>Guidelines : </span>
                                Only new dealers should be added with upload excel.
                            </p>
                        </div>
                    </GuidelineContain>
                    <CommanTableContainDealerMaster>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    {mvrTableCols.map((text, index) => (
                                        <TableCell key={index}>{text}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {dealerData?.map((row, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{row.dealerCode}</TableCell>
                                        <TableCell>{row.dealerName}</TableCell>
                                        <TableCell>{row.phoneNumber}</TableCell>
                                        <TableCell style={{ textTransform: "lowercase" }}>
                                            {row.emailId}
                                        </TableCell>
                                        <TableCell>{row.address}</TableCell>
                                        <TableCell>{row.region}</TableCell>
                                        <TableCell>{row.zone}</TableCell>
                                        <TableCell>{row.area}</TableCell>
                                        <TableCell>{row.country}</TableCell>
                                        <TableCell>{row.state}</TableCell>
                                        <TableCell>{row.city}</TableCell>
                                        <TableCell>{row.pinCode}</TableCell>
                                        <TableCell>{row.loiHolderName}</TableCell>
                                        <TableCell className="upload_img_table">
                                            {row.loiHolderPhoto && (
                                                <img
                                                    src={row.loiHolderPhoto}
                                                    alt="Preview"
                                                    onClick={() => {
                                                        setShowLoiImage(row.loiHolderPhoto);
                                                    }}
                                                />
                                            )}
                                        </TableCell>
                                        <TableCell>{row.loiIssueDate}</TableCell>
                                        <TableCell>{row.mainDealerCode}</TableCell>
                                        <TableCell>{row.mainDealerName}</TableCell>
                                        <TableCell>{row.status}</TableCell>
                                        <TableCell>
                                            <IconButtonContain className="icon_btn_n">
                                                <EditNoteIcon onClick={() => handleEditClick(row)} />
                                                {/* <KeyIcon onClick={handleAiModalOpen} style={{ cursor: "pointer" }} /> */}
                                            </IconButtonContain>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </CommanTableContainDealerMaster>
                </Card>
            </CardContain>
            <TablePagination
                component="div"
                count={totalCount}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            {modalOpen && (
                <HierachyMasterModal className={Drawer ? "" : "DrawerOpen"}>
                    <div className="modal_container_box">
                        <div className="ModalHeader">
                            <h4>Update Data</h4>
                            <button className="CloseButton" onClick={handleModalClose}>
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="ModalBody">
                            <div className="input_form_group">
                                <label htmlFor="">Dealer Code</label>
                                <input value={selectedRow?.dealerCode || ""} disabled />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Dealer Name</label>
                                <input value={selectedRow?.dealerName || ""} disabled />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Contact No.</label>
                                <input
                                    value={selectedRow?.phoneNumber || ""}
                                    onChange={(e) => {
                                        const number = e.target.value;
                                        setSelectedRow({ ...selectedRow, phoneNumber: number });
                                        validatePhone(number);
                                    }}
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Email ID</label>
                                <input
                                    id="email"
                                    type="email"
                                    value={selectedRow?.emailId || ""}
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        setSelectedRow({ ...selectedRow, emailId: email });
                                        validateEmail(email);
                                    }}
                                    required
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">State</label>
                                <input
                                    value={selectedRow?.state || ""}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, state: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Pin Code</label>
                                <input
                                    value={selectedRow?.pinCode || ""}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, pinCode: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Region</label>
                                <input
                                    value={selectedRow?.region || ""}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, region: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Zone</label>
                                <input
                                    value={selectedRow?.zone || ""}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, zone: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">Area</label>
                                <input
                                    value={selectedRow?.area || ""}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, area: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">LOI Holder Name</label>
                                <input
                                    value={selectedRow?.loiHolderName || ""}
                                    onChange={(e) =>
                                        setSelectedRow({
                                            ...selectedRow,
                                            loiHolderName: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <div className="input_form_group date_modal">
                                <label htmlFor="">LOI Issue Date</label>
                                <DatePicker
                                    format="DD-MM-YYYY"
                                    className="date_picker_modal"
                                    value={selectedRow?.loiIssueDate ? dayjs(selectedRow.loiIssueDate, "DD/MM/YYYY") : null}
                                    onChange={(date) => {
                                        setSelectedRow({ ...selectedRow, loiIssueDate: date.format("DD-MM-YYYY") });
                                    }}
                                    slotProps={{
                                        popper: {
                                            style: { zIndex: 99999 },
                                        },
                                    }}
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="">LOI Holder Photo</label>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    {previewImage && (
                                        <img
                                            src={previewImage}
                                            alt="Preview"
                                            style={{
                                                width: "50px",
                                                height: "50px",
                                                objectFit: "cover",
                                            }}
                                        />
                                    )}
                                    <Button
                                        variant="contained"
                                        component="label"
                                        onClick={triggerFileInput}
                                        style={{ margin: "0px 18px", maxHeight: "35px" }}
                                    >
                                        <FileUploadIcon
                                            style={{ cursor: "pointer", marginLeft: "6px" }}
                                        />
                                    </Button>
                                </div>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: "none" }}
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                            </div>

                            <div className="input_form_group">
                                <label htmlFor="">Address</label>
                                <textarea
                                    value={selectedRow?.address || ""}
                                    className="de_textarea"
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, address: e.target.value })
                                    }
                                />
                            </div>
                            <div className="input_form_group">
                                <label htmlFor="status">Status</label>
                                <select
                                    id="status"
                                    className="select_style"
                                    value={selectedRow?.status}
                                    onChange={(e) =>
                                        setSelectedRow({ ...selectedRow, status: e.target.value })
                                    }
                                >
                                    {selectedRow?.status === "Active" ? (
                                        <>
                                            <option
                                                value="active"
                                                className="select_style"
                                                hidden={selectedRow?.status === "Active"}
                                            >
                                                Active
                                            </option>
                                            <option value="Inactive" className="select_style">
                                                Inactive
                                            </option>
                                        </>
                                    ) : (
                                        <>
                                            <option
                                                value="inactive"
                                                className="select_style"
                                                hidden={selectedRow?.status === "Inactive"}
                                            >
                                                Inactive
                                            </option>
                                            <option value="Active" className="select_style">
                                                Active
                                            </option>
                                        </>
                                    )}
                                </select>
                            </div>
                        </div>
                        <div className="">
                            <div
                                className="input_form_group modal_btn_group"
                                style={{ display: "flex", justifyContent: "flex-end" }} // Align button to the right
                            >
                                <ContainedButtton
                                    variant="contained"
                                    onClick={(e) => handleSave(e)}
                                    className="save_btn"
                                    style={{ margin: "7px" }}
                                >
                                    Update
                                </ContainedButtton>
                            </div>
                        </div>
                    </div>
                </HierachyMasterModal>
            )}

            {Boolean(showLoiImage) && (
                <DealerMasterModal className={Drawer ? "" : "DrawerOpen"}>
                    <div className="modal_container_box">
                        <div className="ModalHeader">
                            <h4>LOI Holder Photo</h4>
                            <button
                                className="CloseButton"
                                onClick={() => setShowLoiImage("")}
                            >
                                <CloseIcon />
                            </button>
                        </div>
                        <div className="ModalBody">
                            <img
                                src={showLoiImage}
                                alt="Selected"
                                style={{
                                    width: "100%",
                                    height: "auto",
                                    marginTop: "10px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                }}
                            />
                        </div>
                    </div>
                </DealerMasterModal>
            )}

            <ToastContainer />
      {loader && <Loader fullScreen={true} />}
            {/* </div> */}
        </LocalizationProvider>
    );
};

export default Dealer_Master;
